var map = {
	"./config.dev": 3147,
	"./config.dev.json": 3147,
	"./config.json": 7174,
	"./config.prod": 5013,
	"./config.prod.json": 5013,
	"./config.uat": 4106,
	"./config.uat.json": 4106
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4159;